import { KONAMI_TOGGLED, CODE_TOGGLED } from '../actions/actionTypes';

const intialState = {
  konamiMode: false,
  activeStyle: 'regular',
};

export default (state = intialState, action) => {
  switch (action.type) {
    case KONAMI_TOGGLED:
      return {
        ...state,
        konamiMode: !state.konamiMode,
      };
    case CODE_TOGGLED:
      return {
        ...state,
        activeStyle: state.activeStyle === 'code' ? 'regular' : 'code',
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/styles.js